import api from 'api'
import Constants from 'Constants'

const { SERVER_PORTAL_URL } = Constants

const extendedApi = api.injectEndpoints({
  endpoints: builder => ({
    updateGCPUser: builder.mutation({
      query: body => ({
        method: 'PUT',
        url: `${SERVER_PORTAL_URL}/api/v1/portal-user`,
        body,
      }),
    }),
  }),
})

export const { useUpdateGCPUserMutation } = extendedApi
